import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpAdmit(props) {

  const [inputValue, setInputValue] = useState('');
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [ipData, setIpData] = useState([]);
  const [ipViewData, setIpViewData] = useState([]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  }

  useEffect(() => {
    if (searchClicked) {
      fetchData();
    }
  }, [searchClicked]);

  useEffect(() => {
    if (searchTerm) {
      fetchData();
    }
  }, [searchTerm]);

  function fetchData() {
    setIsLoading(true);
    axios.get(baseUrl + `pat-search/?search=${searchTerm}`)
      .then(response => {
        setPatients(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    try {
      const status = 1;
      axios.get(baseUrl + "ip-request/" + status + "/")
        .then(function (response) {
          setIpData(response.data);
        })
        .catch(function (error) {
          console.log("Error fetching IP data:", error);
        });
    } catch (error) {
      console.log("Error in useEffect:", error);
    }
  }, []);

    useEffect(() => {
      fetchIpViewData();
    }, [ipData.length]);

    function fetchIpViewData() {
      if (ipData.length > 0) {
        const fetchStatusPromises = ipData.map((item) => {
          return axios.get(baseUrl + "fetch-ip-status/" + item.appt.pat.id );
        });

        Promise.all(fetchStatusPromises)
          .then((responses) => {
            const ipViewData = responses.map((response) => response.data);
            const nonEmptyData = ipViewData.filter((data) => data.length > 0); // Filter out empty arrays
            if (nonEmptyData.length > 0) {
              setIpViewData(ipViewData.filter(arr => arr.length > 0));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        setIpViewData([]); // Set an empty array if ipData is empty
      }
    }
    console.log(ipViewData)

  function handleSearchButtonClick() {
    setSearchClicked(true);
  }

  function handleSearchInputChange(event) {
    setSearchTerm(event.target.value);
  }

  const columns = [
  { field: 'id', headerName: 'Id' },
  { field: 'pat_id', headerName: 'Patient ID',
    renderCell: (params) => (
      <Link to={`/ip-pat/${params.value}/`}>
        {params.value}
      </Link>
    )
  },
  { field: 'patient', headerName: 'Patient' },
  { field: 'gender', headerName: 'Gender' },
  { field: 'age', headerName: 'Age' },
  { field: 'marital_status', headerName: 'Marital Status' },
  { field: 'aadhar', headerName: 'Aadhar' },
  { field: 'address1', headerName: 'Address' },
  { field: 'mobile', headerName: 'Mobile' },
  { field: 'occupation', headerName: 'Occupation' },
];


  return (
    <section className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Search Patient</label>
            <div className="col-sm-9 col-lg-10 controls">
              <input className="form-control" type="headerName" placeholder="pat id, address, name, mobile"
                value={searchTerm} onChange={handleSearchInputChange} />
            </div>
          </div>
        </div>
          <div className="col-md-6">
          <div className="form-group">
            <Link to={`/ip-pat-new/`} className="btn btn-success ms-1">
                      New Admission
             </Link>
          </div>
        </div>
      </div>
      {!isLoading && patients.length > 0 ? (
        <div style={{ height: 300, width: '100%' }} className="mt-4">
          <DataGrid
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={patients}
            columns={columns}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
           />
        </div>
      ) : (
        <></>
      )}

  <div className="row mt-4">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
      <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
      Consultant Request
    </h3>
<div className="table-responsive">
      <table className="erp-table-modern">
        <thead>
          <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
            <th>Patient Id</th>
            <th>Patient Name</th>
            <th>Mobile</th>
            <th>Address</th>
            <th>Requested On</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {ipData.map((counts, index) => {
              return (
                <tr key={index}>
                  <td>{counts.appt.pat.pat_id}</td>
                  <td>{counts.appt.pat.patient}</td>
                  <td>{counts.appt.pat.mobile}</td>
                  <td>{counts.appt.pat.address1}</td>
                  <td>{counts.add_date}</td>
                  <td>
                    <Link to={`/ip-pat/${counts.appt.pat.pat_id}/`} className="btn btn-success ms-1">
                      Book Admission
                    </Link>
                  </td>
                </tr>
              );
          })}
        </tbody>
      </table>
  </div>
  </div>
    </section>
  );
}

export default IpAdmit;
